export default __webpack_public_path__ + "static/media/Head_3_Ear_1_C2.cdc71c57.svg";